import React from "react";

/**
 * Standardised section heading used across pages.
 *  - `eyebrow`: small uppercase label
 *  - `title`: main heading (renders as h2 by default)
 *  - `description`: optional supporting copy
 *  - `align`: "left" | "center"
 */
export default function SectionHeader({
  eyebrow,
  title,
  description,
  align = "left",
  theme = "dark",
  children,
  className = "",
}) {
  const alignClasses = align === "center" ? "text-center mx-auto max-w-2xl" : "max-w-3xl";
  const marginClass = className.includes("mb-") ? "" : "mb-14";
  return (
    <div className={`${alignClasses} ${marginClass} ${className}`}>
      {eyebrow && (
        <span className={`welljio-eyebrow mb-5 ${align === "center" ? "justify-center" : ""}`}>
          {eyebrow}
        </span>
      )}
      {title && (
        <h2 className="font-heading text-4xl sm:text-5xl lg:text-[3.5rem] font-semibold tracking-tight leading-[1.02] text-welljio-ink">
          {title}
        </h2>
      )}
      {description && (
        <p className="text-base sm:text-lg text-welljio-muted leading-relaxed mt-5 max-w-xl">{description}</p>
      )}
      {children}
    </div>
  );
}
